<template>
	<main class="common-main-container">
		<div
			style="
        position: fixed;
        top: 70px;
        z-index: 10;
        backdrop-filter: blur(2px);
      "
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<header>
			<section class="d-flex align-items-center">
				<img
					src="../../assets/icons/Reports/bckarrow.svg"
					class="mr-3 pointer"
					alt=""
					@click="$router.push({ name: 'myprojects' })"
				/>
				<h1>{{ editProjects ? "Edit" : "Create" }} Project</h1>
			</section>
		</header>
		<body class="my-2 w-100 custom-fields-body">
			<b-container>
				<body>
					<b-row class="m-0">
						<b-col cols="4">
							<InputComponent
								:validation="$v.createProject.projectTitle.$error"
								:validationMessage="
									!$v.createProject.projectTitle.maxLength
										? 'Should not exceed 1024 characters'
										: null
								"
								v-model="createProject.projectTitle"
								title="Project Title"
							/>
						</b-col>
						<b-col cols="4">
							<SingleSelect
								:validation="$v.createProject.selectedTemplate.$error"
								v-model="createProject.selectedTemplate"
								text="Project Template"
								isMandatory
								:optionsArray="sandboxTemplates"
								nested
							/>
						</b-col>
						<b-col cols="4">
							<FormTags
								:validation="$v.createProject.formTags.$error"
								v-model="createProject.formTags"
							/>
						</b-col>
						<b-col cols="12" class="mt-4">
							<QullEditor
								:validation="$v.createProject.editorContent.$error"
								labelTxt="Project Description"
								v-model="createProject.editorContent"
							/>
						</b-col>
					</b-row>
					<b-row class="m-0 mt-4">
						<b-col cols="4">
							<SingleSelect
								:validation="$v.createProject.selectedCategory.$error"
								v-model="createProject.selectedCategory"
								text="Category"
								isMandatory
								:optionsArray="categories"
							/>
						</b-col>
						<b-col cols="4">
							<SingleSelect
								:validation="$v.createProject.selectedSubCategory.$error"
								:disabled="
									createProject.selectedCategory
										? !createProject.selectedCategory.value
										: true
								"
								v-model="createProject.selectedSubCategory"
								text="Sub Category"
								isMandatory
								:optionsArray="
									createProject.selectedCategory &&
									createProject.selectedCategory.value
										? subCategories[createProject.selectedCategory.value]
										: []
								"
							/>
						</b-col>
						<b-col cols="4">
							<InputComponent
								:validation="$v.createProject.marks.$error"
								v-model="createProject.marks"
								title="Marks"
							/>
						</b-col>
					</b-row>
					<b-row class="m-0 mt-4">
						<b-col cols="4">
							<SingleSelect
								:validation="$v.createProject.selectedDifficultOptions.$error"
								v-model="createProject.selectedDifficultOptions"
								text="Difficulty Level"
								isMandatory
								:optionsArray="difficultoptions"
							/>
						</b-col>
						<b-col cols="8">
							<label
								>Project Check Metrices<span class="asterik">*</span></label
							>
							<div
								style="position: absolute; top: 0px; left: 192px; z-index: 1000"
								v-if="$v.checkingMetrics.$error"
								v-b-popover.hover.top.v-danger="{
									content: 'Please select atleast one check metrices',
								}"
								variant="primary"
							>
								<img src="../../assets/deletepopupicon.svg" alt="" />
							</div>
							<div class="d-flex mt-1 gap-30" v-if="checkboxes.length">
								<SingleCheckbox
									v-for="checkbox in checkboxes"
									:key="checkbox.key"
									v-model="checkbox.isChecked"
									:label="checkbox.name"
								/>
							</div>
						</b-col>
					</b-row>
				</body>
				<footer class="d-flex align-items-center justify-content-end w-100">
					<b-button
						class="new-cancelBtn mr-3"
						@click="$router.push({ name: 'myprojects' })"
						>Cancel</b-button
					>
					<b-button class="new-addBtn mr-3" @click="createprojects">
						{{ editProjects ? "Update" : "Save" }} & Next
					</b-button>
				</footer>
			</b-container>
		</body>
	</main>
</template>

<script>
import InputComponent from "../../components/InputComponents/Input.vue";
import FormTags from "../../components/InputComponents/FormTags.vue";
import QullEditor from "../../components/InputComponents/QullEditor.vue";
import SingleCheckbox from "../../components/InputComponents/SingleCheckbox.vue";
import SingleSelect from "../../components/InputComponents/SingleSelect.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import {
	getSandBoxTemplate,
	createPrject,
	getProject,
	editProject,
	getCheckingMetrics,
	getTemplateReadme,
} from "../../utils//apiFunctions";
import { mapGetters } from "vuex";
import errorToast from "../../views//mixin/toast";
import successToast from "../../views//mixin/toast";
import {
	required,
	numeric,
	minLength,
	maxLength,
} from "vuelidate/lib/validators";

export default {
	data() {
		return {
			editProjects: false,
			sandboxTemplates: [],
			selectedCheckingMetrics: [],
			LoaderStatus: false,
			getProjectData: false,
			updateData: null,
			difficultoptions: [
				{ text: "Difficulty level 1", value: 1 },
				{ text: "Difficulty level 2", value: 2 },
				{ text: "Difficulty level 3", value: 3 },
				{ text: "Difficulty level 4", value: 4 },
				{ text: "Difficulty level 5", value: 5 },
			],
		};
	},
	validations: {
		createProject: {
			projectTitle: {
				required,
				maxLength: maxLength(250),
			},
			marks: {
				required,
				numeric,
			},
			formTags: {
				required,
				minLength: minLength(1),
			},
			selectedTemplate: {
				required,
			},
			selectedCategory: {
				required,
			},
			selectedSubCategory: {
				required,
			},
			selectedDifficultOptions: {
				required,
			},
			editorContent: {
				required,
			},
		},
		checkingMetrics: {
			required,
		},
	},
	mixins: [errorToast, successToast],
	beforeRouteEnter(to, from, next) {
		if (from.name !== "editsandbox") {
			next((vm) => {
				vm.getProjectData = true;
			});
		} else next();
	},
	computed: {
		checkingMetrics() {
			return this.checkboxes
				.map((checkbox) => (checkbox.isChecked ? checkbox.key : null))
				.filter(Boolean);
		},
		...mapGetters("testVUEX", {
			categories: "getCategories",
			subCategories: "getSubCategories",
		}),
		...mapGetters("sandboxVUEX", {
			createProject: "getSandboxDetails",
			checkboxes: "getCheckingMetrics",
		}),
	},
	components: {
		InputComponent,
		FormTags,
		QullEditor,
		SingleCheckbox,
		SingleSelect,
		Spinner,
	},

	async mounted() {
		const templates = await getSandBoxTemplate();
		this.sandboxTemplates = this.getDropdownValues(templates.data.data.data);
		if (this.$route.name == "editprojects") this.editProjects = true;
		if (this.getProjectData) {
			if (this.$route.name === "editprojects") this.editProjectDetails();
			else this.createProject.selectedTemplate = this.sandboxTemplates[0];
		}
	},
	watch: {
		"createProject.selectedCategory"() {
			this.createProject.selectedSubCategory = null;
		},
		async "createProject.selectedTemplate"() {
			this.getCheckingMetrics();
			if (!this.editProjects) this.getTemplateReadme();
		},
	},
	methods: {
		async getTemplateReadme() {
			try {
				const response = await getTemplateReadme(
					this.createProject.selectedTemplate.value
				);
				if (response.status === 200) {
					this.createProject.editorContent = response.data.data;
				} else {
					throw new Error();
				}
			} catch (error) {
				console.log(error);
			}
		},
		async getCheckingMetrics() {
			try {
				const response = await getCheckingMetrics(
					this.createProject.selectedTemplate.value
				);
				if (response.status === 200) {
					this.$store.commit(
						"sandboxVUEX/setCheckingMetrics",
						response.data.data.map((metric) => {
							return {
								isChecked: this.getIsChecked(metric.key),
								...metric,
							};
						})
					);
				} else {
					throw new Error();
				}
			} catch (error) {
				this.errorToast("Something went wrong.");
				console.log(error);
			}
		},
		getIsChecked(key) {
			if (this.checkboxes.length) {
				return this.checkboxes.some(
					(checkbox) => checkbox.key === key && checkbox.isChecked
				);
			} else {
				return this.selectedCheckingMetrics.includes(key);
			}
		},
		async editProjectDetails() {
			this.LoaderStatus = true;
			try {
				const response = await getProject(this.$route.params.id);
				if (response.status === 200) {
					const projectData = response.data.data;

					this.selectedCheckingMetrics = projectData.checkingMetrics;
					this.createProject.projectTitle = projectData.name;
					this.createProject.editorContent = projectData.description;
					this.createProject.selectedDifficultOptions = {
						text: `Difficulty level ${projectData.averageDifficulty}`,
						value: projectData.averageDifficulty,
					};

					this.createProject.selectedCategory = {
						text: projectData.categoryTitle,
						value: projectData.categoryID,
					};

					this.$nextTick(() => {
						this.createProject.selectedSubCategory = {
							text: projectData.subCategoryTitle,
							value: projectData.subCategoryID,
						};
					});

					this.createProject.marks = projectData.marks;
					this.createProject.formTags = projectData.tags;

					this.createProject.selectedTemplate = {
						text: projectData.templateTitle,
						value: projectData.templateID,
					};
				} else {
					throw new Error();
				}
			} catch (error) {
				this.errorToast("Something went wrong.");
				console.log(error);
			} finally {
				this.LoaderStatus = false;
			}
		},
		getDropdownValues(values) {
			return values.map((value) => ({
				text: value.title,
				value: value.questionKey,
				...value,
			}));
		},
		async createprojects() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.errorToast("Please fill all mandatory fields.");
				return;
			}
			this.LoaderStatus = true;
			try {
				const payload = {
					name: this.createProject.projectTitle,
					portion: "SandboxProject",
					templateID: this.createProject.selectedTemplate.value,
					description: this.createProject.editorContent,
					categoryID: this.createProject.selectedCategory.value,
					subCategoryID: this.createProject.selectedSubCategory.value,
					publicAvailability: false,
					active: true,
					checkingMetrics: this.checkingMetrics,
					tags: this.createProject.formTags,
					averageDifficulty: this.createProject.selectedDifficultOptions.value,
					marks: this.createProject.marks,
				};
				if (this.updateData == true) {
					payload.force = true;
				}
				const response = this.editProjects
					? await editProject(this.$route.params.id, payload)
					: await createPrject(payload);
				if (response.status == 200) {
					this.successToast(
						`Project ${this.editProjects ? "updated" : "created"} successfully.`
					);
					setTimeout(() => {
						this.$router.push({
							name: "sharesandbox",
							params: {
								testID: response.data.data.testID,
								topicID: response.data.data.topicID,
							},
							query: {
								type: 4,
								testqp: "outside",
								groupType: "I",
							},
						});
					}, 100);
				} else if (response.status == 409) {
					if (
						response.data.data.testIDs &&
						response.data.data.testIDs.length > 0
					) {
						this.updateData = true;
						this.createprojects();
					} else {
						this.errorToast("Project name already exists in active list.");
					}
				} else {
					this.errorToast(
						"Something went wrong, Unable to create the project."
					);
				}
			} catch (error) {
				console.error(error);
				this.errorToast("Something went wrong, Unable to create the project.");
			} finally {
				this.LoaderStatus = false;
			}
		},
	},
};
</script>

<style scoped>
.red-text {
	color: red;
	font-size: small;
}
</style>
<style>
.sub-txt-chkbx {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 11px;
	color: #3a3c40;
}
.gap-30 {
	gap: 30px;
}
.common-main-container {
	height: calc(100vh - 72px);
	top: 72px;
	padding-left: 80px;
	padding-right: 15px;
	width: auto;
}
</style>
